import type { PropertyPath } from '@/scopes/common/domain/types'
import type { Configuration, ConfigurationClient } from '@/scopes/common/domain/types/configuration'
import * as React from 'react'
import { getIn } from '@/scopes/common/domain/functions/objectDeepOperations'

export const ConfigurationContext = React.createContext<Configuration | null>(null)

export function useConfiguration<P extends string & PropertyPath<Configuration>>(fieldPath: P) {
  return useConfigurationClient().getField(fieldPath)
}

export function useConfigurationClient(): ConfigurationClient {
  const fields = React.use(ConfigurationContext)
  if (!fields) {
    throw new Error('Attempted to use \'useConfiguration\' before initializing ConfigurationContext.')
  }

  return React.useMemo(
    () => ({ getField: fieldPath => getIn(fields, fieldPath) }),
    [fields],
  )
}
